export {
  getRandomThinkingMessage,
  getRelevantThinkingMessage,
} from "@shared/utils";
